import type { TFunction } from 'i18next';

export interface IOption {
  value: 'averages30' | 'averages90';
  label: string;
}

export const getOptions = (t: TFunction): IOption[] => [
  { value: 'averages30', label: t('labels.averages30') },
  { value: 'averages90', label: t('labels.averages90') },
];
